import { create } from 'zustand'
import { combine, createJSONStorage, persist } from 'zustand/middleware'

export const useNavStore = create(
  persist(
    combine(
      {
        initialInvocation: true,
        preNotifcationsNum: 0, 
        validationsNum: 0, 
        needsAttention: false,
        rapbackSubscriptionAttentionShown: false,
        badgeContent: null
      }, (set) => ({
           resetNavStore: () => set({ initialInvocation: true,
            preNotifcationsNum: 0, 
            validationsNum: 0, 
            needsAttention: false,
            rapbackSubscriptionAttentionShown: false,
            badgeContent: null}),
           updatePrenotifications: (numPrenotifications: number) => set((state) => ({ needsAttention: numPrenotifications > 0 && true, preNotifcationsNum: numPrenotifications})),
           updateValidations: (numValidations: number) => set((state) => ({needsAttention: numValidations > 0 && true, validationsNum: numValidations})),
           setInitialInvocationFalse: () => set((state) => ({initialInvocation: false})), 
           setNeedsAttention: (needsAttention) => set({ needsAttention }),
           setRapbackSubscriptionAttentionShown: (rapbackSubscriptionAttentionShown) => set({ rapbackSubscriptionAttentionShown })
         }),
    ), 
    {
      name: "navStore", 
      storage: createJSONStorage(() => sessionStorage),
       merge: (persistedState: any, currentState) => {
                return { ...currentState, ...persistedState }
            },
    }
  )
)
